import { render, staticRenderFns } from "./FlowTest.vue?vue&type=template&id=8c6ec2f6&scoped=true&"
import script from "./FlowTest.vue?vue&type=script&lang=js&"
export * from "./FlowTest.vue?vue&type=script&lang=js&"
import style0 from "./FlowTest.vue?vue&type=style&index=0&id=8c6ec2f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6ec2f6",
  null
  
)

export default component.exports